export enum ApiKeyScopeEnum {
  Rates = 'Rates',
  CreateShipment = 'CreateShipment',
  Users = 'Users'
}
